export default __webpack_public_path__ + "static/img/vogue_scene_animated_0332.a00172e.webp";